const isProduction = process.env.NODE_ENV === 'production';
const enableConsole = !isProduction || process.env.REACT_APP_ENABLE_CLIENT_CONSOLE === 'true';

const normalizeMeta = (meta) => {
  if (!meta || typeof meta !== 'object') return meta;

  // Avoid leaking sensitive fields when logging frontend errors.
  const redactedKeys = ['password', 'passcode', 'token', 'authorization', 'currentPassword', 'newPassword'];
  const output = { ...meta };

  redactedKeys.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(output, key)) {
      output[key] = '[REDACTED]';
    }
  });

  return output;
};

const write = (level, message, meta) => {
  if (!enableConsole) return;

  const payload = normalizeMeta(meta);
  if (payload !== undefined) {
    console[level](message, payload);
  } else {
    console[level](message);
  }
};

const logger = {
  error: (message, meta) => write('error', message, meta),
  warn: (message, meta) => write('warn', message, meta),
  info: (message, meta) => write('info', message, meta)
};

export default logger;
